import { Inbox } from 'lucide-react';

export default function EmptyState({ message = 'Sin datos', icon: Icon = Inbox }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-10 text-text-muted">
      <Icon size={28} />
      <p className="text-sm">{message}</p>
    </div>
  );
}
